<template>
  <div>
    <navigation/>
    <div class="main" style="padding-top: 0px;margin-top: 10px;">
      <div class="rp-contain">
        <div class="rp-title">重置密码</div>
        <div id="step1Div" v-if="stepNum === 1">
          <div class="rp-progress clearfix">
            <div class="progress-items-1">确认账号</div>
            <div class="progress-items-2" @click="reClick(2)" style="cursor:pointer;">安全验证</div>
            <div class="progress-items-3">重置密码</div>
          </div>
          <el-form @keyup.enter.native="submitStep1()" id="step1">
            <div class="rp-list">
              <div class="rp-items">
                <label class="icon-mail"><span></span></label>
                <input type="text" id="username" value="" name="emailOrUsername" v-model="userInfo.userName"
                       maxlength="30" placeholder="请输入邮箱"/>
              </div>
              <div class="rp-items" style="position:relative;">
                <label class="icon-vail"><span></span></label>
                <span
                  style="cursor:pointer;display:block;position:absolute;top:0px;right:0px;border:1px solid #ccc;height:49px;">
						   <img class='rmc_img' id="kaptcha" @click="kaptchaClick" :src="kaptchaUrl"
                    style="height:37px;"
                    alt="验证码"/>
              </span>
                <input type="text" name="kaptcha" id="kaptchaText" v-model="userInfo.verCode" placeholder="请输入验证码"/>
              </div>
            </div>
            <div class="rp-btn" id="submitStep1" @click="submitStep1">
              下一步
            </div>
          </el-form>
        </div>

        <div id="step2Div" v-if="stepNum === 2">
          <div class="rp-progress clearfix">
            <div class="progress-items-1" @click="reClick(1)" style="cursor:pointer;">确认账号</div>
            <div class="progress-items-2 active">安全验证</div>
            <div class="progress-items-3">重置密码</div>
          </div>
          <el-form @keyup.enter.native="submitStep2()" id="step2">
            <input type="hidden" id="userName_step2" name="userName"/>
            <input type="hidden" id="userId_step2" name="id"/>
            <div class="rp-list">
              <div class="rp2-title">为了你的帐号安全，请完成身份验证</div>
              <div class="form-2-label">
                验证码接收邮箱是：<span id="email_step2" style="font-weight: bold; color:#EB3838">{{ userInfo.email }}</span>
              </div>
              <div class="rp-items" style="position:relative;">
                <label class="icon-iphone"><span></span></label>
                <input type="text" placeholder="请输入验证码" v-model="userInfo.emailCode"/>
                <span style="cursor:pointer"><span class="step2-bnt"
                                                   :style="isSend ? 'background-color:#ccc;margin-left: 0px':'background-color:#5289e2;margin-left: 0px'"
                                                   id="sendButton" @click="sendEmail"><span v-if="isSend"
                                                                                            style="background:rgba(0,0,0,0) none repeat scroll !important;">{{
                    downCount
                  }}</span>{{ sendMsg }}</span></span>
              </div>
              <div id="VerificationMesg2"
                   style="color: red; display:none; width:300px;padding-left:12px;margin-top:-18px;">
                <img src="../assets/images/ps5.png" class='rmc-error-img'><span></span>
              </div>
            </div>
            <div class="rp-btn" id="submitStep2" @click="submitStep2">
              下一步
            </div>
          </el-form>
        </div>

        <div id="step3Div" v-if="stepNum === 3">
          <div class="rp-progress clearfix">
            <div class="progress-items-1">确认账号</div>
            <div class="progress-items-2 active">安全验证</div>
            <div class="progress-items-3 active">重置密码</div>
          </div>
          <el-form id="step3"  @keyup.enter.native="submitStep3()">
            <input type="hidden" id="userName_step3" name="userName" value=""/>
            <input type="hidden" id="userId_step3" name="id" value=""/>
            <input type="hidden" id="token_step3" name="token" value=""/>
            <div class="rp-list">
              <div class="form-2-label" style="font-size:16px;">
                您正在重置密码的账号是：<span id="disUserName" style="font-weight: bold; color:#4f4e4f;">{{
                  userInfo.userName
                }}</span>
              </div>
              <div class="rp-items">
                <label class="icon-password"><span></span></label>
                <input type="password" name="passwd" id="passwd" v-model="userInfo.password" placeholder="设置新密码"/>
              </div>
              <div class="rp-items">
                <label class="icon-password"><span></span></label>
                <input type="password" name="repeatPd" id="repeatPd" placeholder="确认新密码" v-model="userInfo.repeatPwd"/>
              </div>
              <div id="VerificationMesg3" style="color:red;display:none;padding-left:12px;margin-top:-18px;">
                <img src="../assets/images/ps5.png" class='rmc-error-img'><span></span>
              </div>
            </div>
            <div class="rp-btn" id="submitStep3" @click="submitStep3">
              确定
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encryption } from '../assets/js/utils'
import navigation from './navigation'

export default {
  name: 'resetPassword',
  components: {
    'navigation': navigation
  },
  data: function () {
    return {
      kaptchaUrl: this.config.kaptchaUrl,
      isSend: false,
      sendMsg: '发送验证码',
      downCount: 60,
      userInfo: {
        password: null,
        repeatPwd: null,
        userName: null,
        verCode: null,
        emailCode: null,
        email: null,
        stepNum: null
      },
      stepNum: 1
    }
  },
  created() {
    this.$nextTick(() => {
      this.kaptchaClick()
    });
    let localDate = localStorage.getItem('send_email')
    if (localDate != null) {
      let timeCount = ((Date.now() - localDate) / 1000).toFixed(0)
      if (timeCount < 60) {
        this.isSend = true
        this.downCount = 60 - timeCount
        var interval = null
        interval = setInterval(() => {
          this.downCount = this.downCount - 1
          if (this.downCount <= 0) {
            if (interval != undefined && interval != null) {
              clearInterval(interval);
            }
            this.sendMsg = '发送验证码'
            this.isSend = false
          }
        }, 1000)
      }
    }
  }, methods: {
    reClick(value) {
      if (value > this.stepNum) {
        return
      }
      this.stepNum = value
    },
    /**
     * 更新验证码
     */
    kaptchaClick() {
      var img = document.getElementById("kaptcha");
      img.setAttribute("src", this.config.kaptchaUrl);
    },
    /**
     * 第一步步骤
     */
    submitStep1() {
      if (this.userInfo.verCode == null) {
        this.$message.warning('请输入验证码!')
        return
      }
      let _self = this
      _self.axios.post(
        _self.api.checkExistUserName, this.userInfo
      ).then(res => {
        if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
          this.kaptchaClick()
        } else {
          this.userInfo.email = res.data.obj.email
          this.userInfo.verCode = null
          this.userInfo.stepNum = 2
          this.stepNum = 2
        }
      }).catch(err => {
        this.$message.error('网络连接异常!')
      })
    },
    /**
     * 验证邮箱验证码是否正确
     */
    submitStep2() {
      if (this.userInfo.emailCode == null) {
        this.$message.warning('请输入邮箱验证码!')
        return
      }
      let _self = this
      _self.axios.post(
        _self.api.checkEmailCode, {email: this.userInfo.email, emailCode: this.userInfo.emailCode}
      ).then(res => {
        res.data.code === 10000
        if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
        } else {
          this.stepNum = 3
          this.userInfo.stepNum = 3
        }
      }).catch(err => {
        this.$message.error('网络连接异常!')
      })
    },
    /**
     * 重置密码
     */
    submitStep3() {
      if (this.userInfo.password == null) {
        this.$message.warning('请设置密码!')
        return
      } else if (this.userInfo.password != null && (this.userInfo.password.length < 8 || this.userInfo.password.length > 16)) {
        this.$message.warning('密码范围在8~16位之间!')
        return
      } else {
        let modes = 0
        if (/\d/.test(this.userInfo.password)) modes++; //数字
        if (/[a-z]/.test(this.userInfo.password)) modes++; //小写
        if (/[A-Z]/.test(this.userInfo.password)) modes++; //大写
        if (modes < 3) {
          this.$message.warning('密码必须包含数字、大小写英文字母！例如:Qzhang888!')
          return
        } else {
          this.passwordMsg = null
        }
      }
      if (this.userInfo.repeatPwd == null || this.userInfo.repeatPwd === '') {
        this.$message.warning('请输入确认密码!')
        return
      }
      if (this.userInfo.password == null || this.userInfo.password === '') {
        this.$message.warning('请输入新密码!')
        return
      }
      if (this.userInfo.password != this.userInfo.repeatPwd) {
        this.$message.warning('两次密码不一致!')
        return
      }
      let _self = this
      let data = {
        emailCode: this.userInfo.emailCode,
        password: encryption(this.userInfo.password, _self.api.aesKey),
        repeatPwd: encryption(this.userInfo.repeatPwd, _self.api.aesKey)
      }
      _self.axios.post(
        _self.api.forgetResetPassword, data
      ).then(res => {
        if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
        } else {
          this.$message.success('修改成功')
          this.$router.push({
            path: '/index'
          })
        }
      }).catch(err => {
        this.$message.error('网络连接异常!')
      })
    },
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    },
    /**
     * 点击发送邮件
     */
    sendEmail() {
      if (this.userInfo.email == null) {
        this.$message.warning('获取异常,请重新申请!')
        return
      }
      if (this.isSend) {
        return
      }
      localStorage.setItem('send_email', Date.now())
      let _self = this
      _self.axios.get(
        _self.api.sendEmailCode
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code === 10000) {
          this.$message.success('发送成功!')
          this.isSend = true
          this.downCount = 60
          this.isSend = true
          this.sendMsg = '秒后重试'
          var interval = null
          interval = setInterval(() => {
            this.downCount = this.downCount - 1
            if (this.downCount <= 0) {
              if (interval != undefined) {
                clearInterval(interval);
              }
              this.sendMsg = '发送验证码'
              this.isSend = false
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    }
  }
}
</script>

<style>
@import '../assets/css/newStyle.css';
</style>



// WEBPACK FOOTER //
// src/components/resetPassword.vue